import React, { FC, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'


import styles from './styles.module.scss'

interface IVariant {
  key: number,
  icons: React.ReactNode[],
  title: string,
  titleButton: string,
  description: React.ReactNode
  variantNumber: React.ReactNode
  variantNumberGrey: React.ReactNode
}

interface IProps {
  variant: IVariant
  error: boolean
  onSelect: (key: number) => void
  selectedVariant: number | null
}


export const HeadsetVariant: FC<IProps> = ({ variant, onSelect, selectedVariant, error }) => {
  const [hover, setHover] = useState(false)

  const onClick = () => {
    onSelect(variant.key)
  }

  const onMouseOver = () => {
    setHover(true)
  }

  const onMouseLeave = () => {
    setHover(false)
  }

  return (
    <button type={'button'}
            onClick={onClick}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
            className={cn(styles.headsetVariant, {
              [styles.headsetVariantSelected]: selectedVariant === variant.key,
              [styles.headsetVariantError]: error
            })}>

      <div className={styles.icons}>
        {variant.icons.map((item, idx) => <React.Fragment key={idx}>{item}</React.Fragment>)}
      </div>
      <div className={styles.title}>{variant.titleButton}</div>
      <div className={styles.variantNumber}>
        {hover || selectedVariant === variant.key ? variant.variantNumber : variant.variantNumberGrey}
      </div>
    </button>
  )
}
